import React from "react"
import PropTypes from "prop-types"

import SignUpContainer from "./SignUpContainer"
import IndividualStep2Form from "../../forms/SignUpForms/IndividualStep2Form"
import SignUpWizard from "../../components/SignUpWizard"

function SignUpIndividualStep3Container({
  onHandleNext,
  onBack,
  handleSaveUser,
  questionnaireData,
  lockedInfo,
}) {
  return (
    <SignUpContainer
      title="Sign Up Process"
      subtitle="Profile Creation"
      description="Complete info to continue to platform"
      onBack={onBack}
      onNext={onHandleNext}
      isButtonSubmit
      useVerticalLayout={true}
      currentStep={3}
      userRole="individual"
      lockedInfo={lockedInfo}
    >
      <IndividualStep2Form
        handleSaveUser={handleSaveUser}
        initialValues={questionnaireData}
        questionnaireData={questionnaireData}
      />
    </SignUpContainer>
  )
}

SignUpIndividualStep3Container.propTypes = {
  user: PropTypes.object,
  onHandleNext: PropTypes.func,
  onHandleRole: PropTypes.func,
  onBack: PropTypes.func,
  handleSaveUser: PropTypes.func,
  questionnaireData: PropTypes.object,
  lockedInfo: PropTypes.array,
}

export default SignUpIndividualStep3Container


